module.exports = "/_next/static/images/77c3939a758824a29c0a296939de7299-pj-phone-and-business-card@2x.jpg";